import { render } from "./settings-screen.vue?vue&type=template&id=41ed307a&ts=true"
import script from "./settings-screen.ts?vue&type=script&lang=ts"
export * from "./settings-screen.ts?vue&type=script&lang=ts"

import "./settings-screen.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__